import React, { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setEnableMobileMenu } from "../../reducers/ThemeOptions";
import cx from "classnames";
import Nav from "../AppNav/VerticalNavWrapper";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import PerfectScrollbar from "react-perfect-scrollbar";
import HeaderLogo from "../AppLogo";

const AppSidebar = () => {
  const dispatch = useDispatch();
  const { enableMobileMenu, enableSidebarShadow, backgroundColor, backgroundImageOpacity } =
    useSelector((state) => ({
      enableMobileMenu: state.ThemeOptions.enableMobileMenu,
      enableSidebarShadow: state.ThemeOptions.enableSidebarShadow,
      backgroundColor: state.ThemeOptions.backgroundColor,
      backgroundImageOpacity: state.ThemeOptions.backgroundImageOpacity,
    }));

  /**
   * Toggles the state of the mobile sidebar menu.
   * This function dispatches an action to the Redux store to update the state of the mobile sidebar menu,
   * enabling or disabling it based on the current state.
   * @function
   * @returns {void} Does not return any value.
   */
  const toggleMobileSidebar = () => {
    dispatch(setEnableMobileMenu(!enableMobileMenu));
  };

  return (
    <Fragment>
      <div className="sidebar-mobile-overlay" onClick={toggleMobileSidebar} />
      <CSSTransitionGroup
        component="div"
        className={cx("app-sidebar", backgroundColor, {
          "sidebar-shadow": enableSidebarShadow,
        })}
        transitionName="SidebarAnimation"
        transitionAppear={true}
        transitionAppearTimeout={1500}
        transitionEnter={false}
        transitionLeave={false}
      >
        <HeaderLogo />
        <PerfectScrollbar>
          <div className="app-sidebar__inner">
            <Nav />
          </div>
        </PerfectScrollbar>
        <div className={cx("app-sidebar-bg", backgroundImageOpacity)} />
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default AppSidebar;
